import maintainRequest from "@/maintain/utils/maintainRequest";

export default function maintainBatchSetCardDeviceType(data) {
  return maintainRequest({
    url: `/user/maintenanceMan/card/batchSetCardDeviceType`,
    method: "post",
    data,
  });
}
